import { isFunction } from '@/global/utils/utils'
import { useAppContext } from '@/global/services/compositionApi/useAppContext'

export function useTranslate () {
  const { trans } = useAppContext()

  const translate = (val) => {
    return isFunction(trans) ? trans(val) : val
  }

  return {
    translate
  }
}
